import * as React from 'react';
import { Helmet } from 'react-helmet';
import { Article } from '../components/articleLists/ArticleInterface';
import { createImageSrc } from '../partials/image/image.utils';

const numArticlesForSchema = 5;

interface ItemsListSchemaProps {
  publisherName: string;
  logoUrl: string;
  itemListElement: Array<Article>;
}

export const sortByDate = (article1: Article, article2: Article) => {
  const article1Time = new Date(article1.featuredAt);
  const article2Time = new Date(article2.featuredAt);
  if (article2Time > article1Time) return 1;
  if (article2Time < article1Time) return -1;
  return 0;
};

const getTopArticlesByDate = (articles: Array<Article>) => articles.sort(sortByDate).splice(0, Math.min(numArticlesForSchema, articles.length));

const getSchema = (topArticles: Array<Article>, publisherName: string, logoUrl: string) => ({
  '@context': 'http://schema.org',
  '@type': 'ItemList',
  itemListElement: topArticles.map((item, position) => {
    const imageUrl = createImageSrc(item.image.host, item.image.path, 600, { x: 16, y: 9 }, 1);
    return {
      '@type': 'NewsArticle',
      position: position + 1,
      url: item.articleUrl,
      headline: item.title,
      image: imageUrl,
      datePublished: item.featuredAt,
      author: {
        '@type': 'Person',
        name: item.author.name,
      },
      publisher: {
        '@type': 'Organization',
        name: publisherName,
        logo: {
          '@type': 'ImageObject',
          url: logoUrl,
        },
      },
    };
  }),
});

export const ItemsListSchema: React.FunctionComponent<ItemsListSchemaProps> = ({ itemListElement, publisherName, logoUrl }) => {
  const topArticles = getTopArticlesByDate(itemListElement);
  const scriptContent = getSchema(topArticles, publisherName, logoUrl);

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(scriptContent)}</script>
    </Helmet>
  );
};
